import { createContext } from 'react';

const grupoContext = createContext();

export default grupoContext;